import Api from '@/services/api';
import type {
	CreateMethodRequestDTO,
	CreateMethodResponseDTO,
	DeleteMethodRequestDTO,
	DeleteMethodResponseDTO,
	GetMethodListRequestDTO,
	GetMethodListResponseDTO,
	GetMethodRequestDTO,
	GetMethodResponseDTO,
	UpdateMethodRequestDTO,
	UpdateMethodResponseDTO
} from '@/core/dto/method';
import type { Method } from '@/types/Method';
import { MethodFindAllMapper } from '@/core/mapper/method-find-all';
import { MethodFindOneMapper } from '@/core/mapper/method-find-one';

export class MethodService {
	private static instance: MethodService;

	private constructor(public readonly basePath: string = '/methods') {}

	public static getInstance(): MethodService {
		if (!MethodService.instance) {
			MethodService.instance = new MethodService();
		}
		return MethodService.instance;
	}

	public async index(params: GetMethodListRequestDTO): Promise<Method[]> {
		const url = this.basePath + '/';
		const { data } = await Api.get<GetMethodListResponseDTO>(url, { params });
		return new MethodFindAllMapper(data).toDomain();
	}

	public async findOne(params: GetMethodRequestDTO): Promise<Method> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await Api.get<GetMethodResponseDTO>(url, { params });
		return new MethodFindOneMapper(data).toDomain();
	}

	public async create(params: CreateMethodRequestDTO): Promise<CreateMethodResponseDTO> {
		const url = this.basePath + '/';
		const { data } = await Api.post<CreateMethodResponseDTO>(url, params);
		return data;
	}

	public async update(params: UpdateMethodRequestDTO): Promise<UpdateMethodResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await Api.put<UpdateMethodResponseDTO>(url, params);
		return data;
	}

	public async delete(params: DeleteMethodRequestDTO): Promise<DeleteMethodResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await Api.delete<DeleteMethodResponseDTO>(url, { params });
		return data;
	}
}

